import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ruJSON from "./ru.json";
import kgJSON from "./kg.json";
import uzJSON from "./uz.json";
import tjJSON from "./tj.json";
import { store } from "../redux/store";

const updateLanguage = () => {
  const currentLanguage = store.getState().info.lang || "ru";
  i18n.changeLanguage(currentLanguage);
  if (typeof document !== "undefined") {
    document.documentElement.lang = currentLanguage;
  }
};

store.subscribe(() => {
  updateLanguage();
});

i18n.use(initReactI18next).init({
  resources: {
    ru: { ...ruJSON },
    kg: { ...kgJSON },
    uz: { ...uzJSON },
    tj: { ...tjJSON },
  },
  lng: store.getState().info.lang,

  fallbackLng: "ru",
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

updateLanguage();

export default i18n;
